var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAddCustomerIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 66,
    height: 69,
    viewBox: "0 0 66 69",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M51.3142 37.7C48.9142 33.9 45.3142 31 41.0142 29.5C37.6142 32.5 33.1142 34.4 28.2142 34.4C23.3142 34.4 18.8142 32.6 15.4142 29.5C8.21415 32 2.91415 38.5 2.11415 46.5L1.01415 58.2C0.714153 61.1 2.71415 63.7 5.51415 64.3L21.4142 67.5C25.9142 68.4 30.6142 68.4 35.1142 67.5L38.8142 66.7C36.0142 63.6 34.3142 59.5 34.3142 55C34.2142 45.6 41.9142 37.9 51.3142 37.7Z",
    fill: "#FD6202"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.2142 28.4C23.3142 29.5 25.7142 30.1 28.2142 30.1C30.7142 30.1 33.1142 29.5 35.2142 28.4C40.0142 25.9 43.2142 20.9 43.2142 15.1C43.2142 6.8 36.5142 0 28.1142 0C19.8142 0 13.0142 6.7 13.0142 15.1C13.2142 20.9 16.4142 25.9 21.2142 28.4Z",
    fill: "#FD6202"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M53.3141 41.7999C52.7141 41.6999 52.2141 41.7 51.6141 41.7C44.2141 41.7 38.2141 47.7 38.2141 55.1C38.2141 59.5 40.3141 63.4 43.5141 65.7999C45.7141 67.5 48.6141 68.4999 51.6141 68.4999C59.0141 68.4999 65.0141 62.5 65.0141 55.1C65.1141 48.3 59.9141 42.5999 53.3141 41.7999ZM57.7141 57.2999H53.7141V61.2999C53.7141 62.1999 53.0141 62.8999 52.1141 62.8999H51.2141C50.3141 62.8999 49.5141 62.1999 49.6141 61.2999V57.2999H45.6141C44.7141 57.2999 43.9141 56.6 44.0141 55.7V54.8999C44.0141 53.9999 44.7141 53.1999 45.6141 53.2999H49.6141V49.2999C49.6141 48.3999 50.3141 47.6 51.2141 47.7H52.0141C52.9141 47.7 53.7141 48.3999 53.6141 49.2999V53.2999H57.6141C58.5141 53.2999 59.3141 53.9999 59.2141 54.8999V55.7999C59.4141 56.4999 58.6141 57.2999 57.7141 57.2999Z",
    fill: "#FD6202"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddCustomerIcon);
export default __webpack_public_path__ + "static/media/addCustomerIcon.0a7485faea95fd4e72b1b403e9bc08b3.svg";
export { ForwardRef as ReactComponent };